import { OpportunitiesReducerState } from './types';

export const initialState: OpportunitiesReducerState = {
  list: [],
  opportunity: null,
  newOpportunity: null,
  assignmentInProgress: false,
};
